module.exports = __webpack_public_path__ + "static/media/ss2020_kaisa_ez_1920x1080.3f16d96c.mp4";